<template>
	<div id="LeavingAmessage">
		<div class="DisplayPanel" ref="chatbox">
			<div class="LeavingAmessage" v-for="(item, key) in data" :key="key">
				<div class="text">{{ item[1] }}</div>
				<div class="name">
					<div>{{ item[0] }}</div>
					<div>{{ item[2] }}</div>
				</div>
			</div>
		</div>
		<div class="input">
			<input class="name" placeholder="昵称" type="text" v-model="name" @keyup.enter="next" autofocus />
			<input class="text" placeholder="留言" type="text" v-model="input" ref="text" @keyup.enter="get" />
		</div>
	</div>
</template>

<script>
	const AV = require('leancloud-storage');
	AV.init({
		appId: "coJvzqIgHkiuWHgUDuMtOC37-gzGzoHsz",
		appKey: "y9tnM5dWs5eC3ubS6OXIrSqm",
		serverURL: "https://cojvzqig.lc-cn-n1-shared.com",
	});
	export default {
		props: ["data1", "data2"],
		name: "LeavingAmessage",
		data() {
			return {
				name: "",
				input: "",
				data: this.data2
			};
		},
		methods: {
			next() {
				this.$refs.text.focus();
			},
			bottom() {
				this.$refs.chatbox.scrollTop = 999999999;
			},
			get() {
				if (this.name == "" || this.input == "") {
					alert("昵称或留言没有填写，这样是不行的哦~");
				} else {
					let time = new Date().toLocaleDateString();
					let input = this.input;
					this.input = "";
					const query = AV.Object.extend("LeavingAmessage")
					const data = new query();
					data.set("comment", [this.name, input, time]);
					data.save().then(
						() => {
							this.$emit("data2", this.data);
							this.data.push([this.name, input, time]);
							setTimeout(()=>{
								this.bottom();
							},100)
						},
						() => {
							alert("网络出错啦！");
						}
					);
				}
			},
		},
		mounted() {
			if (this.data == "") {
				const query = new AV.Query("LeavingAmessage");
				query.find().then(
					(comment) => {
						for (const i of comment) {
							this.data.push(i.attributes.comment);
						}
						this.$emit("data2", this.data);
					}
				);
			}
			setTimeout(()=>{
				this.bottom();
			},100)
		},
	};
</script>

<style scoped>
	.DisplayPanel {
		padding: 20px;
		margin-bottom: 10px;
		height: 300px;
		overflow: auto;
	}

	.DisplayPanel::-webkit-scrollbar {
		display: none;
	}

	.LeavingAmessage {
		display: flex;
		flex-direction: row;
		margin-bottom: 20px;
		justify-content: space-between;
		padding: 10px;
		border: 1px solid gray;
		border-radius: 3px;
		color: rgba(255, 255, 255, 0.8);
	}

	.LeavingAmessage .name {
		font-size: 12px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.LeavingAmessage .text {
		padding-right: 20px;
	}

	.input {
		width: 100%;
	}

	.input>* {
		padding-left: 10px;
		border: 1px solid gray;
		border-radius: 10px;
		background-color: rgba(255, 255, 255, 0.8);
		outline: none;
	}

	.input .name {
		width: 30%;
	}

	.input .text {
		width: 70%;
	}
</style>
